module.exports = __webpack_public_path__ + "img/Correct.2bcdff6c.png";